var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/Header.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import OnScroll from './OnScroll';
import SMHeaderContext from './SMHeaderContext';
import { Addon } from './components/Addon';
import HeaderLogo from './components/HeaderLogo';
import { MobileDrawer } from './components/Drawer/Mobile';
import NavBarAnon from './anonymous/Desktop';
import MobileAnon from './anonymous/Mobile';
import { ValidMenuNameList } from './config/linkInfo';
import { HEADER_COLOR, HEADER_VARIANT } from './enums';
import useHeaderStyles from './useHeaderStyles';
var SMHeader = function SMHeader(_ref) {
  var actionFlow = _ref.actionFlow,
    color = _ref.color,
    ctaRedirectUrl = _ref.ctaRedirectUrl,
    excludeMenuItems = _ref.excludeMenuItems,
    lang = _ref.lang,
    Logo = _ref.Logo,
    isAnonHeaderSticky = _ref.isAnonHeaderSticky,
    isEUDC = _ref.isEUDC,
    isMRX = _ref.isMRX,
    isUserAuthenticated = _ref.isUserAuthenticated,
    showLoginButton = _ref.showLoginButton,
    showSignupButton = _ref.showSignupButton,
    variant = _ref.variant,
    user = _ref.user,
    joinTeamSlug = _ref.joinTeamSlug,
    joinTeamAmplitudeProps = _ref.joinTeamAmplitudeProps;
  var LogoComponent = Logo || HeaderLogo;
  var auth = isUserAuthenticated ? 'auth' : 'anon';
  var headerColor = isUserAuthenticated ? 'primary' : color;
  var headerVariant = isUserAuthenticated ? 'default' : variant;
  var _useHeaderStyles = useHeaderStyles(),
    Header = _useHeaderStyles.Header;
  return /*#__PURE__*/React.createElement(SMHeaderContext.Provider, {
    value: {
      isUserAuthenticated: isUserAuthenticated,
      lang: lang,
      isEUDC: isEUDC,
      isMRX: isMRX,
      actionFlow: actionFlow,
      user: user,
      excludeMenuItems: excludeMenuItems
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(OnScroll, {
    render: function render(x, y) {
      var headerColorAnon = y > 0 ? 'light' : color;
      var smHeaderColor = isUserAuthenticated ? headerColor : headerColorAnon;
      var defaultColor = headerColorAnon === 'transparent' || headerColorAnon === 'primary';
      var logoColor = defaultColor ? 'alt' : 'primary';
      var mobileMenuColor = defaultColor ? 'alt' : 'secondary';
      var addonLogInColor = defaultColor ? 'alt' : 'secondary';
      var navBarColor = defaultColor ? 'alt' : 'secondary';
      var addonSignUpColor = defaultColor ? 'alt' : 'upgrade';
      var addonSignUpVariant = defaultColor ? 'ghost' : 'solid';
      var classNames = "".concat(Header, " ").concat(isAnonHeaderSticky && !isUserAuthenticated ? 'sticky' : '', " ").concat(auth, " ").concat(smHeaderColor, " ").concat(headerVariant, " ").concat(lang === 'en' ? 'lang-en' : '');
      return /*#__PURE__*/React.createElement("div", {
        className: classNames,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(MobileDrawer, {
        menuColor: mobileMenuColor,
        "data-testid": "Header__MobileDrawer--Anon",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(MobileAnon, {
        joinTeamSlug: joinTeamSlug,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 17
        }
      })), /*#__PURE__*/React.createElement(LogoComponent, {
        isUserAuthenticated: isUserAuthenticated,
        variant: variant,
        color: logoColor,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 15
        }
      }), /*#__PURE__*/React.createElement(NavBarAnon, {
        color: navBarColor,
        lang: lang,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 15
        }
      }), /*#__PURE__*/React.createElement(Addon, {
        addonSignUpColor: addonSignUpColor,
        addonLogInColor: addonLogInColor,
        addonSignUpVariant: addonSignUpVariant,
        ctaRedirectUrl: ctaRedirectUrl,
        isUserAuthenticated: isUserAuthenticated,
        showLoginButton: showLoginButton,
        showSignupButton: showSignupButton,
        variant: variant,
        joinTeamSlug: joinTeamSlug,
        joinTeamAmplitudeProps: joinTeamAmplitudeProps,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 15
        }
      }));
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }));
};
SMHeader.propTypes = {
  actionFlow: PropTypes.string,
  color: PropTypes.oneOf(Object.values(HEADER_COLOR)),
  ctaRedirectUrl: PropTypes.string,
  excludeMenuItems: PropTypes.arrayOf(PropTypes.oneOf(ValidMenuNameList)),
  lang: PropTypes.string.isRequired,
  Logo: PropTypes.node,
  isAnonHeaderSticky: PropTypes.bool,
  isEUDC: PropTypes.bool.isRequired,
  isMRX: PropTypes.bool,
  isUserAuthenticated: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  showLoginButton: PropTypes.bool,
  showSignupButton: PropTypes.bool,
  user: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  variant: PropTypes.oneOf(Object.values(HEADER_VARIANT)),
  joinTeamSlug: PropTypes.string,
  joinTeamAmplitudeProps: PropTypes.shape({
    pageName: PropTypes.string,
    guestId: PropTypes.number,
    surveyId: PropTypes.number,
    surveyOwnerId: PropTypes.number
  })
};
SMHeader.defaultProps = {
  actionFlow: 'header',
  ctaRedirectUrl: '',
  color: 'primary',
  excludeMenuItems: [],
  Logo: undefined,
  isAnonHeaderSticky: true,
  isMRX: false,
  isUserAuthenticated: false,
  showLoginButton: true,
  showSignupButton: true,
  variant: 'default',
  joinTeamSlug: undefined,
  joinTeamAmplitudeProps: {}
};
export default SMHeader;
//# sourceMappingURL=Header.js.map